import { IListObj } from "../../../components/types/genericTypes";

export const APITypes: Array<IListObj> = [
  { value: "AV", display: "REST API" },
  { value: "V", display: "Publisher API" },
];

export interface SubscriptionFrom {
  appNm: string;
  rdUrl: string;
  appIcon?: any;
  iconView?: any;
  type: string | number;
  // ip: any;
  primaryIp:any;
  secondaryIp:any;
  ipEditable:boolean
}

export const getAppIcon = (appIcon: any, readerIcon: (val: string) => void) => {
  let reader = new FileReader();
  reader.readAsDataURL(appIcon);
  reader.onload = async (reader: any) => {
    readerIcon(await reader.target.result.split(",")[1]);
  };
};

export const TITLE = {
  EDIT: "Edit Subscription",
  CREATE: "Create Subscription",
};

export interface SubscriptionFromErr {
  appNm: string | undefined;
  rdUrl: string | undefined;
  // ip: any;
  type: string | undefined;
  appIcon?: string | undefined;
  primaryIp:any;
  secondaryIp:any
}

export const SubscriptionFromValue: SubscriptionFrom = {
  appNm: "",
  rdUrl: "https://127.0.0.1/",
  // ip: [""],
  type: APITypes[0].value,
  primaryIp: "",
  secondaryIp: "",
  ipEditable: true,
};

export const SubscriptionFromError: SubscriptionFromErr = {
  appNm: "",
  rdUrl: "",
  type: "",
  // ip: [""],
  appIcon: "",
  primaryIp: "",
  secondaryIp: ""
};
